import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { FormGroup, Col, Label, Input, Row, Button, Spinner } from "reactstrap";
//import DropdownList from 'react-widgets/lib/DropdownList'
//import 'react-widgets/dist/css/react-widgets.css'

import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import DateTimePicker from 'react-widgets/lib/DateTimePicker'

import { AutoComplete as MUIAutoComplete } from 'material-ui'
import { AutoComplete, } from 'redux-form-material-ui'


const renderField = ({
    input,
    type,
    placeholder,
    label,
    disabled,
    readOnly,
    meta: { touched, error, warning },
}) => (
        <Row>
            <Col md="12">
                <Label htmlFor="{input}" className="col-form-label">
                    {label}
                </Label>
            </Col>
            <Col md="12">
                <Input
                    {...input}
                    type={type}
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                ></Input>
                {touched &&
                    ((error && <p style={{ color: "red" }}>{error}</p>) ||
                        (warning && <p style={{ color: "brown" }}>{warning}</p>))}
            </Col>
        </Row>
    );

const validate = values => {
    const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;

    const errors = {}

    //--------------------------------------------------------------------------------------------------------
    const requiredFields5 = [
        'nivel'
    ]

    const requiredFields6 = [
        'nivel2'
    ]

    requiredFields5.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar nivel del alumno';
        }
    })

    

    /*
    requiredFields6.forEach(field => {
        
        if (!values[field]) {
            errors[field] = 'Debes seleccionar grado del alumno';
        }
    })
    */
    //--------------------------------------------------------------------------------------------------------

    if (!values.nombres || values.nombres === "") {
        errors.nombres = "Debes ingresar nombres de alumno";
    }


    if (!values.apellidopaterno || values.apellidopaterno === "") {
        errors.apellidopaterno = "Debes ingresar apellido paterno de alumno";
    }

    
    if (!values.apellidomaterno || values.apellidomaterno === "") {
        errors.apellidomaterno = "Debes ingresar apellido materno de alumno";
    }
    
    return errors
}

const renderFromHelper = ({ touched, error }) => {
    if (!(touched && error)) {
        return
    } else {
        return <FormHelperText>{touched && error}</FormHelperText>
    }
}

const renderSelectField = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Sexo</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'sexo',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField2 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Discapacidad</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'discapacidad',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField3 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Describir Discapacidad</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'discapacidaddescripcion',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField4 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Aptitud</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'aptitud',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField5 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Nivel*</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'nivel',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField6 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Grado*</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'nivel2',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField7 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Grupo*</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'grupo',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField8 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Tutor</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'idtutor',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )


const renderDateTimePicker = ({ input: { onChange, value }, showTime }) =>
    <DateTimePicker
        onChange={onChange}
        format="yyyy/MM/dd"
        time={showTime}
        value={!value ? null : new Date(value)}
    />


/*
 let sexo                    = "";   //Femenino,Masculino
 let discapacidad            = "";   //SI,NO
 let discapacidaddescripcion = "";   //Autismo, Baja Vision, Ceguera, Discapacidad Intelectual, Discapacidad Multiple, Hipoacusia, Otra
 let aptitud                 = "";   //NO,SI
 let nivel                   = "";   //Kinder,Preparatoria,Primaria,Secundaria
 let nivel2                  = "";   //1,2,3,4,5,6
 let grupo                   = "";   //A,B,C
 */

const mapStateToProps = (state) => {

    let idtutor                     = "";
    let apellidopaterno             = "";
    let apellidomaterno             = "";
    let nombres                     = "";
    let sexo                        = "";   //Femenino,Masculino
    let fechanacimiento             = "2021-08-08";
    let estadonacimiento            = "";
    let discapacidad                = "";   //SI,NO
    let discapacidaddescripcion     = "";   //Autismo, Baja Vision, Ceguera, Discapacidad Intelectual, Discapacidad Multiple, Hipoacusia, Otra
    let otra                        = "";
    let aptitud                     = "";   //NO,SI
    let aptituddescripcion          = "";
    let calle                       = "";
    let numero                      = "";
    let colonia                     = "";
    let municipio                   = "";
    let codigopostal                = "0";
    let telefono                    = "";
    let nivel                       = "";   //Kinder,Preparatoria,Primaria,Secundaria
    let nivel2                      = "0";   //1,2,3,4,5,6
    let grupo                       = "";   //A,B,C
    let turno                       = "";
    let baja                        = "false";
    let migrado                     = "false";
    let idusuarioalta               = sessionStorage.getItem('idusuario');
    let alias                       = sessionStorage.getItem('alias');


    return {
        initialValues: {
            idtutor,
            apellidopaterno,
            apellidomaterno,
            nombres,
            sexo,
            fechanacimiento,
            estadonacimiento,
            discapacidad,
            discapacidaddescripcion,
            otra,
            aptitud,
            aptituddescripcion,
            calle,
            numero,
            colonia,
            municipio,
            codigopostal,
            telefono,
            nivel,
            nivel2,
            grupo,
            turno,
            baja,
            migrado,
            idusuarioalta,
            alias
        }
    };

}; //END MAPSTATETOPROPS

const arreglotutor = [];



class FormAlumnoExpress extends Component {

    async componentDidMount() {

        (async () => {
            const response = await fetch('/api/Tutor/ObtieneTodosLosTutor');

            const tutores = await response.json();
            for (var i = 0; i < tutores.length; i++) {
                var nombretutor = tutores[i].apellidopaterno + " " + tutores[i].apellidomaterno + " " + tutores[i].nombres;
                var miobj = new Object();
                miobj.id = tutores[i].idtutor;
                miobj.name = nombretutor;
                arreglotutor.push(miobj);
            }
        })();
        //dataSource={arreglotutor}
        //dataSource={[{ id: 1234, name: 'Facebook' },]}
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>

                <FormGroup row>


                    <Col md={12}>
                        <FormGroup>


                            <Field
                                name="idtutor"
                                component={AutoComplete}
                                floatingLabelText="Buscar tutor*"
                                openOnFocus
                                filter={MUIAutoComplete.fuzzyFilter}
                                dataSourceConfig={{ text: 'name', value: 'id' }}
                                dataSource={arreglotutor}
                                required
                            />

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="nombres"
                                component={renderField}
                                label="Nombres :*"
                            />
                        </FormGroup>
                    </Col>


                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="apellidopaterno"
                                component={renderField}
                                label="Apellido Paterno :*"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="apellidomaterno"
                                component={renderField}
                                label="Apellido Materno :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="nivel"
                                component={renderSelectField5}
                            >
                                <option value="" />
                                <option value={'Maternal'}>Maternal</option>
                                <option value={'Kinder'}>Kinder</option>
                                <option value={'Preparatoria'}>Preparatoria</option>
                                <option value={'Primaria'}>Primaria</option>
                                <option value={'Secundaria'}>Secundaria</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="nivel2"
                                component={renderSelectField6}
                            >
                                <option value="0">Selecciona Grado</option>
                                <option value={'0'}>NA</option>
                                <option value={'1'}>1</option>
                                <option value={'2'}>2</option>
                                <option value={'3'}>3</option>
                                <option value={'4'}>4</option>
                                <option value={'5'}>5</option>
                                <option value={'6'}>6</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="grupo"
                                component={renderSelectField7}
                            >
                                <option value="0">Selecciona Grupo</option>
                                <option value={'0'}>NA</option>
                                <option value={'A'}>A</option>
                                <option value={'B'}>B</option>
                                <option value={'C'}>C</option>
                                <option value={'D'}>D</option>
                                <option value={'E'}>E</option>
                                <option value={'F'}>F</option>
                                <option value={'G'}>G</option>

                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="idusuarioalta"
                                component={renderField}
                                label="ID SUARIO:" disabled
                            />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="alias"
                                component={renderField}
                                label="ALIAS USUARIO:" disabled hidden
                            />
                        </FormGroup>
                    </Col>



                </FormGroup>

                <FormGroup row>
                    <Col md="12">
                        <FormGroup>
                            {
                                !this.props.submitSucceeded ? (
                                    <Button
                                        color="dark"
                                        type="submit"
                                        disabled={this.props.submitSucceeded}

                                    >
                                        Enviar
                                    </Button>
                                ) : (
                                        <Button variant="success" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                variant="success"
                                                role="status"
                                            />
                                            Procesando solicitud...
                                        </Button>

                                    )

                            }

                        </FormGroup>
                    </Col>
                </FormGroup>

            </form>
        );
    }
}

FormAlumnoExpress = reduxForm({
    form: "FormAlumnoExpress",
    validate,
    enableReinitialize: true,
})(FormAlumnoExpress);
export default connect(mapStateToProps, null)(FormAlumnoExpress);
